import React from "react";
import { Check, ChevronRight } from "lucide-react";

const STEPS = [
  { full: "Documents", short: "Docs" },
  { full: "Category", short: "Cat." },
  { full: "Budget", short: "Budget" },
  { full: "Details", short: "Details" },
  { full: "Review", short: "Review" },
];

const BEATS = [
  "Start with your files",
  "Pick the procedure path",
  "Set a draft budget",
  "Add a few care details",
  "Double-check, then send",
];

/**
 * Single stepper for `/request/:id/*` wizard pages.
 * Do not stack the post-submit journey strip here — that lives on Care Price / home.
 */
export default function WizardSteps({ active }) {
  const safeActive = Math.min(Math.max(0, Number(active) || 0), STEPS.length - 1);

  return (
    <div className="reqWizard__stepperWrap">
      <p className="reqWizard__stepperSummary">
        Step {safeActive + 1} of {STEPS.length} · <strong>{STEPS[safeActive].full}</strong>
        <span className="reqWizard__stepperBeat"> — {BEATS[safeActive]}</span>
      </p>
      <ol className="reqWizard__steps">
        {STEPS.map((step, index) => {
          const done = index < safeActive;
          const isActive = index === safeActive;
          return (
            <li key={step.full} className="reqWizard__stepItem">
              <span className={`reqWizard__step ${isActive ? "is-active" : done ? "is-done" : ""}`}>
                <span className="reqWizard__stepNum">{done ? <Check size={14} /> : index + 1}</span>
                <span className="reqWizard__stepLabel">
                  <span className="reqWizard__stepLabelFull">{step.full}</span>
                  <span className="reqWizard__stepLabelShort" aria-hidden="true">
                    {step.short}
                  </span>
                </span>
              </span>
              {index < STEPS.length - 1 ? (
                <ChevronRight size={14} className="reqWizard__chev" aria-hidden />
              ) : null}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
